import { tgxApi } from "../../../app/tgxApi";
import { getAuthorizationHeader, handleQueryError } from "../../../helpers/utils/RtkQueryUtils";
import { downloadFile, openFileInFrame, openFileInNewTab } from "../../../helpers/utils/FileUtils";
import { log } from "console";

export const documentsApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({
        getTgxFilesByRelationId: build.query({
            query: (query) => {
                return {
                    url: `/ajax/tgx-files/search`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: query
                };
            },
            providesTags: ["getAllFilesByRelationId"],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        getAllDocuments: build.query({
            query: (query) => {
                return {
                    url: `/ajax/document/search`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: query
                };
            },
            providesTags: ["getAllDocuments"],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        loadFiles: build.mutation<Blob, string>({
            query: (fileId) => {
                return {
                    url: `/ajax/download-association-file/${fileId}`,
                    method: 'GET',
                    headers: {
                        ...getAuthorizationHeader(),
                    },
                    responseHandler: (response: any) => response.blob(),
                    responseType: 'blob',
                }
            },
            async onQueryStarted(fileId, { queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled; // data is now correctly typed as Blob
                    const fileUrl = URL.createObjectURL(data);
                    const iframe = document.querySelector("iframe");


                    if (iframe) {
                        iframe.src = fileUrl;
                        iframe.onload = () => {
                            URL.revokeObjectURL(fileUrl);
                        };
                    } else {
                        console.error("No iframe element found to display PDF");
                    }
                } catch (error) {
                    console.error("Failed to load association file:", error);
                }
            },
        }),

        donwLoadFiles: build.query({

            query: ({ fileId, isDownload, isOpenInFrame }) => {
                return {
                    url: `/ajax/download-association-file/${fileId}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                    responseHandler: async (response: any) => {
                        const blob = await response.blob();
                        if (!isOpenInFrame) {
                            const contentDisposition = response.headers.get('Content-Disposition');
                            const filename = contentDisposition
                                ? contentDisposition.split('filename=')[1]
                                : `file_${fileId}.pdf`;

                            isDownload ? downloadFile(blob, filename) : openFileInNewTab(blob)
                        } else {
                            openFileInFrame(blob);
                        }
                        return { success: true };
                    },
                };

            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
    }),


})


export const {
    useGetAllDocumentsQuery,
    useGetTgxFilesByRelationIdQuery,
    useLoadFilesMutation,
    useLazyDonwLoadFilesQuery

} = documentsApi;